import { render, staticRenderFns } from "./NewClasses.vue?vue&type=template&id=358d6b0a"
import script from "./NewClasses.vue?vue&type=script&lang=js"
export * from "./NewClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports